import api from './api';

export interface PoolMember {
  id: string;
  organizationId: string;
  fullName: string;
  phone: string;
  email: string;
  vehicleInfo?: string;
  plate?: string;
  notes?: string;
  isActive: boolean;
  groupId: string | null;
  group?: { id: string; name: string } | null;
  createdAt: string;
}

export interface CreatePoolMemberDto {
  fullName: string;
  phone: string;
  email: string;
  password?: string;
  vehicleInfo?: string;
  plate?: string;
  notes?: string;
  isActive?: boolean;
  groupId?: string | null;
}

export const poolMembersService = {
  getMe: async (): Promise<PoolMember> => {
    const response = await api.get('/pool-members/me');
    return response.data;
  },

  getAll: async (groupId?: string): Promise<PoolMember[]> => {
    const params = groupId ? { groupId } : {};
    const response = await api.get('/pool-members', { params });
    return response.data;
  },

  create: async (data: CreatePoolMemberDto): Promise<PoolMember> => {
    const response = await api.post('/pool-members', data);
    return response.data;
  },

  update: async (id: string, data: CreatePoolMemberDto): Promise<PoolMember> => {
    const response = await api.patch(`/pool-members/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/pool-members/${id}`);
  },
};
